import { useId, useLayoutEffect } from 'react'
import { useIfcStore } from '@stores'

/**
 * Registers a request to disable IFC GLB model hover/selection while `disable` is true. Backed by
 * an id-keyed map in the ifc store (à la `useModelSelectionV2`), so the hook can be used from
 * multiple places at once — the model stays non-selectable while any caller requests it. The
 * registration is keyed by a stable per-instance id and cleared on unmount.
 */
const useDisableIFCSelection = (disable: boolean): void => {
  const id = useId()
  const setIfcSelectionDisabled = useIfcStore(state => state.setIfcSelectionDisabled)
  const clearIfcSelectionDisabled = useIfcStore(state => state.clearIfcSelectionDisabled)

  useLayoutEffect(() => {
    setIfcSelectionDisabled(id, disable)
    return () => clearIfcSelectionDisabled(id)
  }, [id, disable, setIfcSelectionDisabled, clearIfcSelectionDisabled])
}

export default useDisableIFCSelection
